/* SS 14.09.2026 - price-history pill, see assets/ss-pdp-pills.css.
   The Compliance Tracker app fills its <a class="price-history-trigger"> with
   "Høyest til lavest pris siste 90 dager: 599 kr - 499 kr" (or "Høyest og lavest pris siste 90 dager: 599 kr")
   after fetching /apps/compliance, and again on variant change. We shorten it to "<label>: <lowest price><suffix>",
   e.g. "Siste 90 dager: 499 kr", and keep the full sentence as the title attribute. The label comes from a data
   attribute on .ss-price-pill (set per store in Liquid). */
(function () {
  'use strict';
  function toNumber(s) {
    s = s.replace(/[^\d.,]/g, '');
    var dec = s.match(/[.,](\d{1,2})$/);            // "599,00" / "599.5" -> decimals
    var whole = dec ? s.slice(0, dec.index) : s;   // "1 299" / "1.299" -> thousands
    var n = parseFloat(whole.replace(/[.,]/g, '') + (dec ? '.' + dec[1] : ''));
    return isNaN(n) ? null : n;
  }
  /* 15.09.2026 - format-agnostic: the app's sentence ends with one price or "high - low" in the store's own
     currency format ("599 kr - 499 kr", "€59.95 - €49.95", "59,95 € - 49,95 €"). We keep the lowest token exactly as the
     app wrote it, so no locale formatting lives here. Label comes from data-ss-pill-label (set per store in Liquid). */
  function shorten(wrap) {
    var a = wrap.querySelector('.price-history-trigger');
    if (!a) return;
    var label = wrap.getAttribute('data-ss-pill-label') || 'Siste 90 dager';
    var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.indexOf(label + ':') === 0) return;   // empty, or already ours
    var i = text.indexOf(':');
    if (i < 0) return;
    var parts = text.slice(i + 1).split(/\s+[-\u2013\u2014]\s+|\s+(?:til|till|to|bis|tot)\s+/).map(function (p) { return p.trim(); }).filter(Boolean);
    var best = null, bestN = Infinity;
    for (var k = 0; k < parts.length; k++) { var n = toNumber(parts[k]); if (n !== null && n < bestN) { bestN = n; best = parts[k]; } }
    if (best === null) return;
    /* Dmytro-Claude - optional decimal separator from data-ss-pill-decimal (DE/NL/FI: ","): the app always writes a "."
       decimal for EUR ("5.56 €"), whatever the store's money format [best] */
    var dec = wrap.getAttribute('data-ss-pill-decimal');
    if (dec) best = best.replace(/(\d)\.(\d{2})(?!\d)/, '$1' + dec + '$2');
    a.textContent = label + ': ' + best;
    a.setAttribute('title', text);
    a.setAttribute('data-ss-ready', '1');
  }
  function watch(wrap) {
    shorten(wrap);
    new MutationObserver(function () { shorten(wrap); })
      .observe(wrap, { childList: true, subtree: true, characterData: true });
  }
  /* Kristoffer 15.09: no hover behaviour - the app shows its tooltip graph on mouseenter after 300 ms; we stop the
     mouse events in the capture phase before they reach the app's listener on the trigger. Click still opens the modal. */
  ['mouseenter', 'mouseover'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var el = e.target;
      if (el && el.closest && el.closest('.ss-price-pill')) { e.stopImmediatePropagation(); e.stopPropagation(); }
    }, true);
  });
  function init() {
    var wraps = document.querySelectorAll('.ss-price-pill');
    for (var k = 0; k < wraps.length; k++) watch(wraps[k]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
